import type { JumpChart } from '../jumpChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_AMBER } from '../builtinPulseMaps/palettes.js';
import { assembleJumpChartFromCircles } from './jumpFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/cradles.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/cradles-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/cradles-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/cradles-extreme.circles.json' with { type: 'json' };

export const CRADLES_JUMP_VARIANTS: Record<Variant, JumpChart> = assembleJumpChartFromCircles({
  baseSlug: 'cradles',
  baseTitle: "Cradles",
  description: "Sub Urban's dark alt-pop. Snappy snares and vocal-led groove, cube-jump interpretation.",
  difficulty: 3,
  palette: PALETTE_AMBER,
  attribution: "\"Cradles\" by Sub Urban [NCS Release] - https://ncs.io/Cradles",
  mapper: "DaKawaliKid",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 80, offsetMs: 0, totalBeats: 83 },
    hard: { bpm: 80, offsetMs: 0, totalBeats: 83 },
    extreme: { bpm: 80, offsetMs: 0, totalBeats: 83 },
  },
});
